/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewDataleakEvent
 */
export interface CRSFSecReviewDataleakEvent {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleakEvent
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleakEvent
     */
    name: string;
}

/**
 * Check if a given object implements the CRSFSecReviewDataleakEvent interface.
 */
export function instanceOfCRSFSecReviewDataleakEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CRSFSecReviewDataleakEventFromJSON(json: any): CRSFSecReviewDataleakEvent {
    return CRSFSecReviewDataleakEventFromJSONTyped(json, false);
}

export function CRSFSecReviewDataleakEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDataleakEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'name': json['name'],
    };
}

export function CRSFSecReviewDataleakEventToJSON(value?: CRSFSecReviewDataleakEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'name': value.name,
    };
}

